(() => {
  const dialog = document.querySelector('#sz-policy-dialog'), configNode = document.querySelector('#sz-policy-config');
  if (!dialog || !configNode) return;
  const config = JSON.parse(configNode.textContent), root = window.Shopify?.routes?.root || '/';
  const checkbox = dialog.querySelector('[data-sz-policy-accept]'), marketing = dialog.querySelector('[data-sz-marketing-agree]');
  const phone = dialog.querySelector('#sz-marketing-phone'), phoneWrap = dialog.querySelector('[data-sz-marketing-phone-wrap]');
  const save = dialog.querySelector('[data-sz-policy-save]'), error = dialog.querySelector('[data-sz-policy-error]');
  const list = dialog.querySelector('[data-sz-policy-items]'), restrictions = dialog.querySelector('[data-sz-policy-restrictions]');
  const terms = dialog.querySelector('[data-sz-policy-terms]').textContent.trim();
  const label = dialog.querySelector('[data-sz-marketing-label]').textContent.trim();
  const disclosure = dialog.querySelector('[data-sz-marketing-disclosure]').textContent.trim();
  const policyText = 'I agree to Speedzone’s purchase, return and fraud-review policies.';
  const shippingText = 'I understand that standard checkout does not include optional shipping protection. Speedzone will assist with available carrier documentation, but loss, theft or damage in transit will not be covered by Speedzone beyond remedies required by applicable law.';
  let pending = null, pendingForm = null, snapshot = '', busy = false, permit = false, requestedProtection = false;

  // Use category metadata as well as the existing explicit policy tags.
  // Boundaries avoid matching Toyota, radiator caps, or card payment accessories.
  const categoryFinalSale = item => [item.productType || '', ...(item.collections || []), ...(item.tags || [])]
    .some(value => /(?:^|[\s_>\/-])(?:die[ -]?cast|collectibles?|collectables?|trading[ -]?cards?|tcg|toys?|apparel|clothing|t[ -]?shirts?|shirts?|hoodies?|sweatshirts?|headwear|hats?|jackets?|socks|pants|shorts)(?:$|[\s_>\/-])/i.test(value));

  const relevant = items => items.map(item => {
    const tags = [...(item.tags || [])];
    if (categoryFinalSale(item)) tags.push('SZ_POLICY_ACK_REQUIRED', 'SZ_POLICY_COLLECTIBLE_APPAREL');
    return {...item, tags:[...new Set(tags)].filter(tag => tag.startsWith('SZ_POLICY_')).sort()};
  }).filter(item => item.tags.includes('SZ_POLICY_ACK_REQUIRED'));

  const signature = items => JSON.stringify(items.map(({key, variant, quantity, tags}) => ({key, variant, quantity, tags})).sort((a,b) => a.key.localeCompare(b.key)));

  function fingerprint(context) {
    return signature(context.items) + '|' + context.protected;
  }

  async function readContext() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id','sz-policy-cart-data');
    url.searchParams.set('preview_theme_id',config.theme);
    url.searchParams.set('_policy',Date.now());

    const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw Error(config.error);

    const doc = new DOMParser().parseFromString(await response.text(),'text/html');
    const data = JSON.parse(doc.querySelector('[data-sz-policy-cart]')?.textContent || 'null');

    if (!data || !Array.isArray(data.items) || !data.items.length) {
      throw Error('Your cart is empty. Return to your cart to continue.');
    }

    // Use a fresh cart read for insurance state; never infer it from the clicked button.
    const cartResponse = await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if (!cartResponse.ok) throw Error(config.error);

    const cart = await cartResponse.json();
    if (!Array.isArray(cart.items)) throw Error(config.error);

    const key = items => JSON.stringify(items.map(i=>[i.key,i.quantity]).sort((a,b)=>a[0].localeCompare(b[0])));
    if (key(data.items)!==key(cart.items)) throw Error(config.changed);

    return {
      items:data.items,
      protected:cart.items.some(item=>item.handle==='insureshield-shipping-insurance-product')
    };
  }

  async function write(attributes) {
    const response = await fetch(root+'cart/update.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes})
    });

    if (!response.ok) throw Error(config.error);

    const cart = await response.json();
    for (const [key,value] of Object.entries(attributes)) {
      if ((cart.attributes?.[key]||'')!==value) throw Error(config.error);
    }
  }

  function render(context) {
    list.replaceChildren();
    const items = relevant(context.items);
    restrictions.hidden = !items.length;

    for (const item of items) {
      const li = document.createElement('li');
      const reasons = item.tags.map(tag=>config.reasons[tag.replace('SZ_POLICY_','')]).filter(Boolean);
      li.textContent = item.title+' × '+item.quantity+' — '+reasons.join('; ');
      list.append(li);
    }

    dialog.querySelector('[data-sz-policy-shipping]').textContent = context.protected
      ? 'Your cart includes optional shipping protection. Its coverage terms apply.'
      : requestedProtection
        ? 'You selected the protected-checkout option. Confirm that optional coverage is added at checkout; coverage terms apply.'
        : shippingText;

    snapshot = fingerprint(context);
    checkbox.checked = false;
    marketing.checked = false;
    phoneWrap.hidden = false;
    save.disabled = true;
  }

  function replay() {
    const action = pending;
    pending = null;
    dialog.close();

    const fields = [...(pendingForm?.querySelectorAll('input[name="updates[]"]')||[])].filter(field=>!field.disabled);
    fields.forEach(field=>{field.disabled=true});
    permit=true;

    try {
      action?.();
    } finally {
      setTimeout(()=>{
        permit=false;
        fields.forEach(field=>{field.disabled=false});
      },0);
    }
  }

  async function start(action,form,protectedPath=false) {
    if (busy || pending) return;

    busy=true;
    pending=action;
    pendingForm=form;
    requestedProtection=protectedPath;
    error.textContent=config.loading;

    checkbox.checked=false;
    checkbox.disabled=true;
    marketing.checked=false;
    marketing.disabled=true;
    phoneWrap.hidden=false;
    save.disabled=true;
    list.replaceChildren();
    restrictions.hidden=true;
    dialog.showModal();

    try {
      render(await readContext());
      error.textContent='';
    } catch(e) {
      pending=null;
      error.textContent=e.message||config.error;
    } finally {
      busy=false;
      checkbox.disabled=!pending;
      marketing.disabled=!pending;
    }
  }

  checkbox.addEventListener('change',()=>{
    save.disabled=!checkbox.checked||busy||!pending;
  });

  marketing.addEventListener('change',()=>{
    phoneWrap.hidden=false;
    if(marketing.checked) phone.focus();
  });

  save.addEventListener('click',async()=>{
    if (!checkbox.checked || busy || !pending) return;

    let number=phone.value.trim().replace(/[\s().-]/g,'');
    if (/^[2-9]\d{9}$/.test(number)) number='+1'+number;
    if (/^1[2-9]\d{9}$/.test(number)) number='+'+number;

    if (marketing.checked&&!/^\+1[2-9]\d{9}$/.test(number)) {
      error.textContent='Enter a valid US mobile number for optional texts, or leave that box unchecked to continue.';
      phone.focus();
      return;
    }

    busy=true;
    save.disabled=true;
    checkbox.disabled=true;
    marketing.disabled=true;
    phone.disabled=true;
    error.textContent='';

    try {
      const context=await readContext();

      if (fingerprint(context)!==snapshot) {
        render(context);
        error.textContent=config.changed;
        return;
      }

      const items=relevant(context.items), at=new Date().toISOString();

      const attributes={
        sz_checkout_policy_choice:'accepted',
        sz_checkout_policy_text:policyText,
        sz_checkout_policy_version:config.version,
        sz_checkout_policy_utc:at,
        sz_checkout_policy_url:location.origin+'/pages/purchase-communication-policies',

        sz_return_ack_v1:items.length?terms:'',
        sz_policy_version:items.length?config.version:'',
        sz_policy_url:items.length?location.origin+'/pages/shipping-returns':'',
        sz_policy_accepted_utc:items.length?at:'',
        sz_policy_items:items.length?JSON.stringify(items.map(({id,variant,title,sku,quantity,tags})=>({id,variant,title,sku,quantity,tags}))):'',

        'Shipping protection declined':context.protected||requestedProtection?'':'Declined - customer acknowledged in checkout review',
        'Shipping protection decision':context.protected?'Protected':requestedProtection?'Protection requested':'Declined',
        'Shipping checkout path':context.protected||requestedProtection?'Protected checkout':'Standard checkout',
        'Shipping acknowledgment version':'SZ-SP-2026-10-26-v3',
        'Shipping policy URL':location.origin+'/pages/purchase-communication-policies#purchase-policies',
        'Shipping acknowledgment text':context.protected
          ?'Cart includes optional shipping protection. Coverage terms apply.'
          :requestedProtection
            ?'Customer selected protected checkout; coverage must be added and confirmed at checkout.'
            :shippingText,
        'Shipping acknowledgment UTC':at,

        // Never turn store-policy acceptance or marketing permission into fraud-SMS consent.
        sz_sms_consent_v1:'no',
        sz_sms_consent_phone:'',
        sz_fraud_review_method:'email_or_staff',

        sz_recovery_sms_choice:marketing.checked?'requested':'declined',
        sz_recovery_sms_phone:marketing.checked?number:'',
        sz_recovery_sms_text:label+' '+disclosure,
        sz_recovery_sms_version:config.smsVersion,
        sz_recovery_sms_browser_utc:at,
        sz_recovery_sms_source:'Optional marketing SMS in checkout review',
        sz_recovery_sms_theme:String(config.theme)
      };

      await write(attributes);
      const fresh=await readContext();

      if (fingerprint(fresh)!==snapshot) {
        await write({
          sz_checkout_policy_choice:'',
          sz_return_ack_v1:'',
          sz_policy_items:'',
          sz_recovery_sms_choice:'declined',
          sz_recovery_sms_phone:''
        });

        render(fresh);
        error.textContent=config.changed;
        return;
      }

      replay();
    } catch(e) {
      error.textContent=e.message||config.error;
    } finally {
      busy=false;
      checkbox.disabled=false;
      marketing.disabled=false;
      phone.disabled=false;
      save.disabled=!checkbox.checked||!pending;
    }
  });

  dialog.querySelector('[data-sz-policy-cancel]').addEventListener('click',()=>{
    if(!busy){
      pending=null;
      dialog.close();
    }
  });

  dialog.addEventListener('cancel',event=>{
    if(busy) event.preventDefault();
    else pending=null;
  });

  window.addEventListener('click',event=>{
    if(permit||!(event.target instanceof Element)) return;

    const target=event.target.closest('button[name="checkout"],input[name="checkout"],a[href],.checkout-cart-widget');
    if(!target||target.disabled||dialog.contains(target)) return;

    const checkoutLink=target.matches('a[href]')&&/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkouts?(?:\/|$)/.test(new URL(target.href,location.href).pathname);

    if(!checkoutLink&&!target.matches('[name="checkout"],.checkout-cart-widget')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    void start(()=>target.click(),target.closest('form'),target.matches('.checkout-cart-widget'));
  },true);

  window.addEventListener('submit',event=>{
    if(permit||event.submitter?.name!=='checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    void start(()=>event.target.requestSubmit(event.submitter),event.target);
  },true);

  // The former shipping checkbox owned this initial disabled class.
  // Enable checkout buttons only after the unified interception is installed.
  function enableCheckout(rootNode=document) {
    rootNode.querySelectorAll('[data-sz-unified-shipping]').forEach(note=>{
      const form=note.closest('form');
      if(!form) return;

      form.querySelectorAll('[data-cart-checkout-buttons]').forEach(group=>{
        group.classList.remove('cart__buttons--disabled');
      });

      form.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach(button=>{
        button.disabled=false;
        button.setAttribute('aria-disabled','false');
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>enableCheckout());
  } else {
    enableCheckout();
  }

  new MutationObserver(()=>enableCheckout()).observe(document.documentElement,{
    childList:true,
    subtree:true
  });
})();
